export default __webpack_public_path__ + "static/media/find.ffbb0157.png";